// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__2XcPw","name":"Header_name__2WjTi","birthday":"Header_birthday__2CZV3","skeleton":"Header_skeleton__qTFJQ"};